export const MATERIAL_CONFIG: {[key: string]: {[key: string]: string | number | boolean | object}} = {
  snackBar: {
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
    panelClass: 'info'
  },
  progressSpinner: {
    diameter: 20
  },
  expansionPanel: {
    hideToggle: false,
    expandedHeight: 'auto',
    collapsedHeight: 'auto',
  },
  dialog: {
    autoFocus: false,
    disableClose: true,
    hasBackdrop: true,
    panelClass: ['dialog-medium']
  },
  label: {
    floatLabel: 'always'
  },
  dateFormat: {
    parse: {
      dateInput: [
        // not-delimited
        'ddMMyyyy',
        // dash-delimited
        'dd-MM-yyyy',
        'd-MM-yyyy',
        'dd-M-yyyy',
        'd-M-yyyy',
        // dot-delimited
        'dd.MM.yyyy',
        'd.MM.yyyy',
        'dd.M.yyyy',
        'd.M.yyyy',
        // slash-delimited
        'dd/MM/yyyy',
        'd/MM/yyyy',
        'dd/M/yyyy',
        'd/M/yyyy',
      ]
    },
    display: {
      dateInput: 'dd/MM/yyyy',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'dd/MM/yyyy',
      monthYearA11yLabel: 'MMMM yyyy'
    }
  },
  paginator: {
    pageSizeOptions: [5, 10, 25, 50, 100],
    pageSize: 50,
    showFirstLastButtons: true
  },
  ripple: {
    disabled: true
  }
};
